const menuEl = () => {
  return document.querySelector('.hamburger');
};

const headerEl = () => {
  return document.querySelector('header');
};

export const hideMainNavigation = () => {
  if (menuEl()) {
    menuEl().classList.add('hidden');
  }
  if (headerEl()) {
    headerEl().classList.add('hidden');
  }
};

export const showMainNavigation = () => {
  if (menuEl()) {
    menuEl().classList.remove('hidden');
  }

  if (headerEl()) {
    headerEl().classList.remove('hidden');
  }
};
